import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fdbd8a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view add-user" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "users__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "add-user__title" }, "Add user")
], -1))
const _hoisted_3 = { class: "add-user__form-panel" }
const _hoisted_4 = { class: "add-user__form-section" }
const _hoisted_5 = { class: "add-user__form-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-user__headline" }, "Informations", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-user__text" }, "Provide all informations to add a user", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "User type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "access-code" }, "Access code", -1))
const _hoisted_10 = {
  key: 0,
  class: "add-user__code-error"
}
const _hoisted_11 = {
  class: "add-user__switch-label",
  for: "debug"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Debug option ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-user__bot-buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button--big button--green" }, "Add User")
], -1))
const _hoisted_14 = { class: "add-user__form-section" }
const _hoisted_15 = { class: "add-user__form-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-user__headline" }, "Groups", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-user__text add-user__text--groups" }, "Add your user to specific group", -1))
const _hoisted_18 = { class: "groups" }
const _hoisted_19 = { class: "add-user__upload-bar" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drag and drop files to here to upload.", -1))
const _hoisted_21 = {
  key: 0,
  class: "add-user__upload-error"
}
const _hoisted_22 = {
  key: 1,
  class: "add-user__upload-progress"
}
const _hoisted_23 = { class: "add-user__spinner" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-user__upload-info" }, "User creation in progress, this process could take a while. You can close this tab, but will not be able to see the results of the upload.", -1))
const _hoisted_25 = { class: "add-user__progress-bar" }
const _hoisted_26 = { class: "add-user__progress-bar-rail" }
const _hoisted_27 = { class: "add-user__progress-percentage" }
const _hoisted_28 = { class: "add-user__table" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"add-user__table-head\" data-v-6fdbd8a0><div class=\"add-user__table-row\" data-v-6fdbd8a0><div class=\"add-user__table-cell table__email\" data-v-6fdbd8a0>Email</div><div class=\"add-user__table-cell table__name\" data-v-6fdbd8a0>First name</div><div class=\"add-user__table-cell table__user-type\" data-v-6fdbd8a0>User type</div><div class=\"add-user__table-cell table__access-code\" data-v-6fdbd8a0>Access code</div><div class=\"add-user__table-cell table__debug\" data-v-6fdbd8a0>Debug option</div><div class=\"add-user__table-cell table__success\" data-v-6fdbd8a0>Upload success</div><div class=\"add-user__table-cell table__groups\" data-v-6fdbd8a0>Groups</div><div class=\"add-user__table-cell table__comment\" data-v-6fdbd8a0>Comment</div></div></div>", 1)
const _hoisted_30 = { class: "add-user__table-body" }
const _hoisted_31 = { class: "add-user__table-cell table__email" }
const _hoisted_32 = { class: "add-user__table-cell table__name" }
const _hoisted_33 = { class: "add-user__table-cell table__user-type" }
const _hoisted_34 = { class: "add-user__table-pill pill pill--blue" }
const _hoisted_35 = { class: "add-user__table-cell table__access-code" }
const _hoisted_36 = { class: "add-user__table-cell table__debug" }
const _hoisted_37 = { class: "add-user__table-cell table__success" }
const _hoisted_38 = { class: "add-user__table-cell table__groups" }
const _hoisted_39 = { class: "add-user__table-cell table__comment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TabMenu, {
      model: _ctx.tabMenu,
      class: "add-user__tabs",
      onTabChange: _ctx.onTabChange
    }, null, 8, ["model", "onTabChange"]),
    (_ctx.activeTab == 0)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.user.userType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.userType) = $event)),
                  options: _ctx.userTypeOptions,
                  optionLabel: "label",
                  optionValue: "value",
                  placeholder: "User type",
                  class: "drop"
                }, null, 8, ["modelValue", "options"]),
                (['ControlClinic', 'ExperimentalClinic'].includes(_ctx.user.userType))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_9,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "access-code",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.code) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.user.code]
                      ]),
                      (_ctx.codeErrorMsg)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.codeErrorMsg), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Switch, {
                    modelValue: _ctx.user.isTester,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.isTester) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedGroup,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedGroup) = $event)),
                    options: _ctx.groups,
                    optionLabel: "name",
                    placeholder: "Choose group",
                    class: "drop",
                    filter: true,
                    filterPlaceholder: "Find a group"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.activeTab == 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_FileUpload, {
              name: "demo[]",
              accept: ".csv",
              customUpload: true,
              maxFileSize: 1000000,
              onUploader: _ctx.onUpload,
              previewWidth: 0
            }, {
              empty: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["onUploader"])
          ]),
          (_ctx.errorMsg)
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.errorMsg), 1))
            : _createCommentVNode("", true),
          (_ctx.isUploading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_ProgressSpinner, {
                    style: {"width":"30px","height":"30px"},
                    strokeWidth: "4",
                    animationDuration: "1s"
                  })
                ]),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", {
                      class: "add-user__progress-bar-fill",
                      style: _normalizeStyle({'width': `${_ctx.progressPercentage}%`})
                    }, null, 4)
                  ]),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.progressPercentage) + " %", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableUsers, (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "add-user__table-row",
                  key: user?.externalId
                }, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(user.email), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(user.name), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.uploadedUserTypeEnum[user.userType]), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(user.loginCode), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["material-icons", user.isTester ? 'green' : 'red'])
                    }, _toDisplayString(user.isTester ? 'check_circle' : 'cancel'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["material-icons", user.isSuccess ? 'green' : 'red'])
                    }, _toDisplayString(user.isSuccess ? 'check_circle' : 'cancel'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(user.group), 1),
                  _createElementVNode("div", _hoisted_39, _toDisplayString(user.result), 1)
                ]))
              }), 128))
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}